import React, { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";
import moment from "moment-timezone";

import { useRouter } from "../util/router";
import { useSite } from "../util/sites.js";
import GYAxios from "../util/GYAxios.js";

import Loader from "../components/general/Loader";

function SignOnPage() {
	const currentSites = useSite();
	const router = useRouter();
	const { keycloak, initialized } = useKeycloak();

	/**
	 * Redirect to valid route if authenticated
	 * @param {Router} router
	 * @param {Attribute to validate} attr
	 * @param {Valid route} validRoute
	 */
	const validateAttr = (router, attr, validRoute) => {
		// Redirect to valid route
		if (typeof attr !== "undefined" && attr != "") router.push(validRoute);
		// License in progress
		else router.push("/solar/inprogress");
	};

	useEffect(() => {
		currentSites.clearSites();
	}, []);

	useEffect(() => {
		if (initialized && !keycloak.authenticated) keycloak.login();
	}, [initialized]);

	useEffect(() => {
		if (keycloak.authenticated) {
			const userObj = keycloak.idTokenParsed;
			const keycloakID = userObj.sub;

			// Update last connection date time into db
			const now = moment().format("YYYY-MM-DD HH:mm:ss");
			const updateParam = {
				last_connection: now,
			};

			GYAxios.patch(`/users/${keycloakID}/init/signin`, updateParam);

			GYAxios.get(`/users/${keycloakID}/init/signin`).then((res) => {
				const userInfo =
					res.data.error == null && res.data.length > 0 ? res.data[0] : false;

				if (userInfo) {
					// Validate user roles
					if (userObj.roles != null) {
						// GY User access
						if (userObj.roles.includes("_GY:Base")) {
							router.push("/solar/overview");
						}
						// Client access
						else {
							// HQ or Multiple site
							if (userObj.roles.includes("_CLIENT:Multi"))
								validateAttr(router, userInfo.client_id, `/solar/overview`);
							// Single site - client site access
							else {
								validateAttr(
									router,
	 								userInfo.site_id,
									`/solar/dashboard/${userInfo.site_id}`
								);
							}
						}
					}
					// User is not assigned a group in Keycloak
					else router.push("/solar/error");
				} else router.push("/solar/error");
			});
		}
	}, [keycloak.authenticated]);

	return (
		<div style={{ height: "89vh" }}>
			<Loader />
		</div>
	);
}

export default SignOnPage;
